import type { CarEnergy$options } from '$houdini';
import * as m from '$paraglide/messages';

const carEnergyLabel: Record<CarEnergy$options, () => string> = {
	BIFUEL: m.itinerary__options__car_energy__bifuel,
	CNG: m.itinerary__options__car_energy__cng,
	DIESEL: m.itinerary__options__car_energy__diesel,
	ELECTRIC: m.itinerary__options__car_energy__electric,
	GASOLINE: m.itinerary__options__car_energy__gasoline,
	HYBRID: m.itinerary__options__car_energy__hybrid,
	HYDROGEN: m.itinerary__options__car_energy__hydrogen,
	LPG: m.itinerary__options__car_energy__lpg,
	ETHANOL: m.itinerary__options__car_energy__ethanol,
};

export function carEnergies(energy: CarEnergy$options): string {
	return carEnergyLabel[energy]();
}
